import React from 'react';
import logo from '../../images/logo-kunera-white.svg';

const Logo = () => {
  return <img src={logo} alt="Kunera logo" />;
};

export default Logo;
